(function () {
  'use strict';

  const MODAL_ID = 'tara-consultation-recovery-modal';
  const OPEN_CLASS = 'tara-qr--recovery-open';

  function getStore() {
    return window.__taraConsultationResultsStore || null;
  }

  function getState() {
    const store = getStore();
    return store && typeof store.getState === 'function' ? store.getState() : null;
  }

  function getHelpers() {
    const store = getStore();
    return store && typeof store.getHelpers === 'function' ? store.getHelpers() : null;
  }

  function normalizeKey(value) {
    const cartApi = window.TaraConsultationResultsCart || null;
    if (cartApi && typeof cartApi.normalizeKey === 'function') {
      return cartApi.normalizeKey(value);
    }

    return (value || '').toString().toLowerCase().trim();
  }

  function replaceTokens(template, values) {
    const cartApi = window.TaraConsultationResultsCart || null;
    if (cartApi && typeof cartApi.replaceTokens === 'function') {
      return cartApi.replaceTokens(template, values);
    }

    return template || '';
  }

  function sumQuantities(items) {
    return (items || []).reduce(function sum(total, item) {
      return total + (Number(item && item.quantity) || 0);
    }, 0);
  }

  function getRemainingItems(routinePurchase, selectedHandle) {
    if (!routinePurchase || routinePurchase.mode !== 'multi_item') return [];

    const normalizedSelectedHandle = normalizeKey(selectedHandle);
    return (routinePurchase.addItems || []).filter(function filterItem(item) {
      return normalizeKey(item && item.handle) !== normalizedSelectedHandle;
    });
  }

  function getRemainingProducts(state, remainingItems) {
    const productsByHandle = state && state.productsByHandle && typeof state.productsByHandle === 'object'
      ? state.productsByHandle
      : {};

    return remainingItems
      .map(function mapItem(item) {
        return item && item.handle ? productsByHandle[item.handle] || null : null;
      })
      .filter(Boolean);
  }

  function setRecoveryLock(isLocked) {
    document.documentElement.classList.toggle(OPEN_CLASS, isLocked);
    document.body.classList.toggle(OPEN_CLASS, isLocked);
  }

  function ensureModal() {
    let modal = document.getElementById(MODAL_ID);
    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'tara-qr__recovery-modal';
    modal.hidden = true;
    modal.innerHTML = [
      '<div class="tara-qr__recovery-backdrop" data-recovery-close></div>',
      '<div class="tara-qr__recovery-dialog" role="dialog" aria-modal="true" aria-labelledby="tara-qr-recovery-title">',
      '  <button class="tara-qr__recovery-close" type="button" aria-label="Close" data-recovery-close>&times;</button>',
      '  <div class="tara-qr__recovery-content">',
      '    <p class="tara-qr__recovery-kicker" data-recovery-kicker hidden></p>',
      '    <h3 class="tara-qr__recovery-title" id="tara-qr-recovery-title" data-recovery-title></h3>',
      '    <p class="tara-qr__recovery-body" data-recovery-body></p>',
      '    <div class="tara-qr__recovery-list-wrap" data-recovery-list-wrap hidden>',
      '      <p class="tara-qr__recovery-list-label" data-recovery-list-label></p>',
      '      <ul class="tara-qr__recovery-list" data-recovery-list></ul>',
      '    </div>',
      '    <div class="tara-qr__recovery-actions">',
      '      <button class="button add-to-cart-button tara-qr__atc tara-qr__recovery-primary" type="button" data-recovery-primary></button>',
      '      <button class="button tara-qr__recovery-secondary" type="button" data-recovery-secondary></button>',
      '    </div>',
      '  </div>',
      '</div>',
    ].join('');

    document.body.appendChild(modal);
    return modal;
  }

  function closeModal(modal) {
    if (!(modal instanceof HTMLElement)) return;
    modal.hidden = true;
    setRecoveryLock(false);
  }

  function openModal(modal) {
    if (!(modal instanceof HTMLElement)) return;
    modal.hidden = false;
    setRecoveryLock(true);
  }

  function buildRecoveryModel(state, routinePurchase, selectedHandle) {
    const i18n = state && state.config ? state.config.i18n || {} : {};
    const remainingItems = getRemainingItems(routinePurchase, selectedHandle);
    const remainingProducts = getRemainingProducts(state, remainingItems);
    const remainingCount = sumQuantities(remainingItems);
    const discountPercent = Number(routinePurchase && routinePurchase.offer && routinePurchase.offer.discountPercent) || 0;

    return {
      remainingItems,
      remainingProducts,
      remainingCount,
      title: i18n.recoveryTitle || 'Complete your routine before checkout',
      body: discountPercent > 0
        ? replaceTokens(i18n.recoveryBodyDiscount || 'Add the remaining {{ count }} items to keep your {{ percent }}% consultation offer.', {
          count: String(remainingCount),
          percent: String(discountPercent),
        })
        : replaceTokens(i18n.recoveryBodyDefault || 'Add the remaining {{ count }} items to take the full routine with you.', {
          count: String(remainingCount),
        }),
      listLabel: i18n.recoveryRemainingLabel || 'Still missing',
      primaryLabel: replaceTokens(i18n.recoveryAddRemaining || 'Add remaining {{ count }} items', {
        count: String(remainingCount),
      }),
      secondaryLabel: i18n.recoveryContinueCheckout || 'Continue to checkout',
      kicker: discountPercent > 0
        ? replaceTokens(i18n.recoveryDiscountKicker || 'Keep your {{ percent }}% offer', {
          percent: String(discountPercent),
        })
        : '',
    };
  }

  function populateModal(modal, model) {
    if (!(modal instanceof HTMLElement) || !model) return;

    const kicker = modal.querySelector('[data-recovery-kicker]');
    const title = modal.querySelector('[data-recovery-title]');
    const body = modal.querySelector('[data-recovery-body]');
    const listWrap = modal.querySelector('[data-recovery-list-wrap]');
    const listLabel = modal.querySelector('[data-recovery-list-label]');
    const list = modal.querySelector('[data-recovery-list]');
    const primary = modal.querySelector('[data-recovery-primary]');
    const secondary = modal.querySelector('[data-recovery-secondary]');

    if (kicker instanceof HTMLElement) {
      kicker.textContent = model.kicker || '';
      kicker.hidden = !model.kicker;
    }

    if (title instanceof HTMLElement) {
      title.textContent = model.title || '';
    }

    if (body instanceof HTMLElement) {
      body.textContent = model.body || '';
    }

    if (listWrap instanceof HTMLElement && listLabel instanceof HTMLElement && list instanceof HTMLElement) {
      list.innerHTML = '';
      model.remainingProducts.forEach(function appendProduct(product) {
        const item = document.createElement('li');
        item.className = 'tara-qr__recovery-item';
        item.textContent = product.title || product.handle || '';
        list.appendChild(item);
      });
      listLabel.textContent = model.listLabel || '';
      listWrap.hidden = !model.remainingProducts.length;
    }

    if (primary instanceof HTMLButtonElement) {
      primary.textContent = model.primaryLabel || '';
      primary.disabled = false;
    }

    if (secondary instanceof HTMLButtonElement) {
      secondary.textContent = model.secondaryLabel || '';
      secondary.disabled = false;
    }
  }

  function waitForRecoveryChoice(modal, model) {
    populateModal(modal, model);
    openModal(modal);

    return new Promise(function waitForChoice(resolve) {
      const primary = modal.querySelector('[data-recovery-primary]');
      const secondary = modal.querySelector('[data-recovery-secondary]');
      const closeTriggers = Array.from(modal.querySelectorAll('[data-recovery-close]'));

      function cleanup() {
        if (primary instanceof HTMLElement) {
          primary.removeEventListener('click', onPrimary);
        }
        if (secondary instanceof HTMLElement) {
          secondary.removeEventListener('click', onSecondary);
        }
        closeTriggers.forEach(function removeClose(trigger) {
          trigger.removeEventListener('click', onClose);
        });
      }

      function onPrimary() {
        cleanup();
        resolve({
          choice: 'complete',
          button: primary,
        });
      }

      function onSecondary() {
        cleanup();
        closeModal(modal);
        resolve({
          choice: 'checkout',
          button: secondary,
        });
      }

      function onClose() {
        cleanup();
        closeModal(modal);
        resolve({
          choice: 'dismiss',
          button: null,
        });
      }

      if (primary instanceof HTMLElement) {
        primary.addEventListener('click', onPrimary);
      }
      if (secondary instanceof HTMLElement) {
        secondary.addEventListener('click', onSecondary);
      }
      closeTriggers.forEach(function addClose(trigger) {
        trigger.addEventListener('click', onClose);
      });
    });
  }

  async function startSingleItemFlow(payload) {
    const variantId = payload && payload.variantId;
    const button = payload && payload.button;
    const selectedHandle = payload && payload.selectedHandle;
    const helpers = getHelpers();
    const state = getState();

    if (!variantId || !(button instanceof HTMLElement) || !helpers || !state) {
      return null;
    }

    const routinePurchase = state.routinePurchase || null;
    const addResult = await helpers.addToCart(variantId, button, 1, null, {
      openDrawerOnSuccess: false,
      redirectToCheckout: false,
    });

    if (!addResult || !addResult.ok) {
      return addResult;
    }

    if (!routinePurchase || routinePurchase.mode !== 'multi_item') {
      return {
        ok: true,
        redirected: true,
        url: await helpers.redirectToCheckout(null),
      };
    }

    const model = buildRecoveryModel(state, routinePurchase, selectedHandle);
    if (!model.remainingItems.length) {
      return {
        ok: true,
        redirected: true,
        url: await helpers.redirectToCheckout(null),
      };
    }

    const modal = ensureModal();
    const decision = await waitForRecoveryChoice(modal, model);

    if (decision.choice === 'complete') {
      return helpers.addItemsToCart(
        model.remainingItems,
        decision.button,
        routinePurchase.offer && routinePurchase.offer.isLive ? routinePurchase.offer.activation : null,
        {
          openDrawerOnSuccess: false,
          redirectToCheckout: true,
        }
      );
    }

    if (decision.choice === 'checkout') {
      return {
        ok: true,
        redirected: true,
        url: await helpers.redirectToCheckout(null),
      };
    }

    return {
      ok: true,
      redirected: false,
      dismissed: true,
    };
  }

  window.TaraConsultationResultsConversion = Object.freeze({
    getRemainingItems,
    startSingleItemFlow,
  });
})();
